module.exports = __webpack_public_path__ + "static/GreycliffCF-Medium-32a7e69655a504f8a0aa3abe05357d18.otf";